import { MetaInterface, OfferInterface } from '@sport-activities/sdk';

import { CheckoutItemInterface } from '~/checkout/interfaces/checkout-item.interface';
import { Subscriber } from '~/checkout/interfaces/subscriber.interface';
import { toIntegerPrice } from '~/core/helpers/numbers.helper';
import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { BmsTermsInterface } from '../components/pages/payment/onepay/payment-onepay.component';

export class CheckoutItem implements CheckoutItemInterface {
  public activity: Activity;
  public adults?: Array<Subscriber> = [];
  public bmsTerms?: BmsTermsInterface[];
  public children?: Array<Subscriber> = [];
  public defaultOffer: string;
  public meta?: MetaInterface; // = meta on booking item
  public timeslot: Timeslot;

  constructor(init?: Partial<CheckoutItem>) {
    Object.assign(this, init);
  }

  get adultsTotalPrice(): number {
    return this.sumCollectionPrices(this.adults);
  }

  get childrenTotalPrice(): number {
    return this.sumCollectionPrices(this.children);
  }

  get currency(): string {
    return this.offer.currency;
  }

  get isFree(): boolean {
    return +this.offer.price === 0;
  }

  get numberOfAdults(): number {
    return this.adults.length;
  }

  get numberOfAttendees(): number {
    return this.children.length + this.adults.length;
  }

  get numberOfChildren(): number {
    return this.children.length;
  }

  get offer(): OfferInterface {
    return this.timeslot.offers.find((o) => o.identifier === this.defaultOffer);
  }

  get totalPrice(): number {
    return this.adultsTotalPrice + this.childrenTotalPrice;
  }

  private sumCollectionPrices(subscribers: Subscriber[]): number {
    return (
      subscribers.reduce((acc) => acc + toIntegerPrice(this.offer.price), 0) /
      100
    );
  }
}
